export default __webpack_public_path__ + "static/media/Graphics_Fodler1-min.b536072c.jpg";